import { Routes } from '@angular/router';
const ɵ0 = () => import("./home/home.module.ngfactory").then(m => m.HomeModuleNgFactory), ɵ1 = () => import("./collections/collections.module.ngfactory").then(m => m.CollectionsModuleNgFactory), ɵ2 = () => import("./dance/dance.module.ngfactory").then(m => m.DanceModuleNgFactory), ɵ3 = () => import("./sessions/sessions.module.ngfactory").then(m => m.SessionsModuleNgFactory);
const routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: '_',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        loadChildren: ɵ0
    },
    {
        path: 'collections',
        loadChildren: ɵ1
    },
    {
        path: 'dance',
        loadChildren: ɵ2
    },
    {
        path: 'sessions',
        loadChildren: ɵ3
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
